import { configuredProductConstants } from '../constant/configuredProduct'


export default function configuredProduct(state = {}, action) {
  switch (action.type) {

    case configuredProductConstants.READ_CONFIGURED_PRODUCTS_SUCCESS:
      return { ...state, totalCount: action.resp.totalCount }

    // case configuredProductConstants.READ_CONFIGURED_PRODUCTS_SUCCESS:
    //   return { ...state, readAll: action.resp, isReady: true }

    // case configuredProductConstants.READ_CONFIGURED_PRODUCTS_FAILURE:
    //   return { ...state, isReady: true }

    default:
      return state
  }
}